import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { RiveDirective } from '@examdojo/ui/rive';
import { TranslocoPipe } from '@jsverse/transloco';
import { ImageComponent } from '@examdojo/core/ui/image';
import { QuestionBankService } from '../../app/question-bank.service';

@Component({
  selector: 'dojo-question-bank-empty-state',
  templateUrl: './question-bank-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonComponent, IconComponent, TranslocoPipe, ImageComponent, RiveDirective],
})
export class QuestionBankEmptyStateComponent {
  constructor(private readonly questionBankService: QuestionBankService) {}

  readonly imageSrc = input<string>('assets/images/senpei/senpei-no-results.svg');
  readonly riveConfig = input<{ file: string; artboard: string; stateMachine: string }>();
  readonly title = input.required<string>();

  clearAllFilters(): void {
    this.questionBankService.clearFilters();
  }
}
